import { Navigate, useLocation } from 'react-router-dom';

export function LegacyPatientsRedirect() {
  const location = useLocation();
  const nextPath =
    location.pathname.replace(/^\/patients(?=\/|$)/, '/users') +
    location.search +
    location.hash;

  return <Navigate to={nextPath} replace />;
}
